import { TRACKING_OPERATION, TRACKING_SECTION, TRACKING_TARGET, TRACKING_TYPE } from '@/utils/constants';
import { dispatchTrack } from '@/utils/tracking';
import { REPLY_TYPE } from '@/utils/responseHandler';
import { observable, action } from 'mobx';
import inputStore from './input';

export class ModalStore {
  // modal - 文章
  @observable isShowModalArticle = false;
  @observable isVisibleModalArticle = false;
  @observable modalArticle = {};

  // modal - Order列表
  @observable isShowModalOrderList = false;
  @observable isVisibleModalOrderList = false;

  // modal - cast card
  @observable isShowModalCsatCard = false;
  @observable showModalCsatCardAlready = false;

  @observable modalOrderList = {};

  // 进线参数
  @observable startAgentParmas = {};

  // modal - ACL选 cancel reason
  @observable isShowModalOrderCancelReason = false;
  @observable isVisibleModalOrderCancelReason = false;
  @observable modalOrderCancelReason = {};

  // modal - Enquiry Details
  @observable isShowModalEnquiryDetails = false;
  @observable isVisibleModalEnquiryDetails = false;
  @observable modalEnquiryDetails = {};

  // pop up announcement
  @observable popUpAnnouncementShow = false;
  @observable popUpAnnouncementData = {};

  // 提示更新 app 版本 modal
  @observable isShowModalUpdateApp = false;

  @observable articleDetailTrackingData = {
    startTime: new Date(),
    articleScrolls: 0,
    tableScrolls: 0,
    articleScrollToEnd: false,
  };

  // 新的 全局的 modal 变量
  globalModalConfig = {
    visible: false,
    hide: () => {},
  };

  constructor() {
    // this.isShowModalArticle = false;
    // this.isVisibleModalArticle = false;
    // this.modalArticle = {};

    // this.isShowModalOrderList = false;
    // this.isVisibleModalOrderList = false;
    // this.modalOrderList = {};

    // this.isShowModalOrderCancelReason = false;
    // this.isVisibleModalOrderCancelReason = false;
    // this.modalOrderCancelReason = {};

    // this.isShowModalEnquiryDetails = false;
    // this.isVisibleModalEnquiryDetails = false;
    // this.modalEnquiryDetails = {};

  }

  // article
  @action
  UPDATE_MODAL_ARTICLE(data) {
    this.modalArticle = data;
  }

  @action
  SHOW_CSAT_MODAL() {
    this.isShowModalCsatCard = true;
    this.showModalCsatCardAlready = true;
    inputStore?.inputRef?.current?.blur();
  }

  @action
  UNSHOW_CSAT_MODAL() {
    this.isShowModalCsatCard = false;
  }

  @action
  SHOW_ARTICLE_MODAL() {
    this.isShowModalArticle = true;
    inputStore?.inputRef?.current?.blur();
    setTimeout(() => {
      this.VISIBLE_ARTICLE_MODAL();
    }, 100);
  }

  @action
  VISIBLE_ARTICLE_MODAL() {
    this.isVisibleModalArticle = true;
  }

  @action
  HIDE_ARTICLE_MODAL() {
    const trackingName = TRACKING_TYPE.CLOSE_ARTICLE;
    const { startTime, articleScrolls, tableScrolls, articleScrollToEnd } = this.articleDetailTrackingData;
    const trackingData = {
      ...this.modalArticle.trackingArticleDetailBasicData,
      view_duration: Math.floor((new Date().getTime() - startTime.getTime()) / 1000),
      article_scrolls: articleScrolls,
      table_scrolls: tableScrolls,
      article_scroll_to_end: articleScrollToEnd ? 0 : 1,
    };

    dispatchTrack({
      operation: TRACKING_OPERATION.CLICK,
      target: TRACKING_TARGET[trackingName],
      section: TRACKING_SECTION[trackingName],
      data: trackingData,
    });

    this.UNVISIBLE_ARTICLE_MODAL();
    setTimeout(() => {
      this.UNSHOW_ARTICLE_MODAL();
      this.UPDATE_MODAL_ARTICLE({});
      this.UPDATE_MODAL_ARTICLE_DETAIL_TRACKING_DATA({
        startTime: new Date(),
        articleScrolls: 0,
        tableScrolls: 0,
        articleScrollToEnd: false,
      });
    }, 400);
  }

  @action
  UNSHOW_ARTICLE_MODAL() {
    this.isShowModalArticle = false;
  }

  @action
  UNVISIBLE_ARTICLE_MODAL() {
    this.isVisibleModalArticle = false;
  }

  // Order list
  @action
  SHOW_ORDERLIST_MODAL() {
    this.isShowModalOrderList = true;
    setTimeout(() => {
      this.VISIBLE_ORDERLIST_MODAL();
    }, 100);
  }

  @action
  VISIBLE_ORDERLIST_MODAL() {
    if (this.isShowModalOrderList) {
      this.isVisibleModalOrderList = true;
    }
  }

  @action
  HIDE_ORDERLIST_MODAL() {
    this.UNVISIBLE_ORDERLIST_MODAL();
    setTimeout(() => {
      this.UNSHOW_ORDERLIST_MODAL();
      this.UPDATE_MODAL_ORDER_LIST({});
    }, 400);
  }

  @action
  UNSHOW_ORDERLIST_MODAL() {
    this.isShowModalOrderList = false;
  }

  @action
  UNVISIBLE_ORDERLIST_MODAL() {
    this.isVisibleModalOrderList = false;
  }

  @action
  UPDATE_MODAL_ORDER_LIST(data) {
    this.modalOrderList = data;
  }

  @action
  UPDATE_START_AGENT_PARMAS(data) {
    this.startAgentParmas = data;
  }

  // ACL - order cancel reasons
  @action
  SHOW_ORDERCANCELREASON_MODAL() {
    this.isShowModalOrderCancelReason = true;
    setTimeout(() => {
      this.VISIBLE_ORDERCANCELREASON_MODAL();
    }, 100);
  }

  @action
  VISIBLE_ORDERCANCELREASON_MODAL() {
    if (this.isShowModalOrderCancelReason) {
      this.isVisibleModalOrderCancelReason = true;
    }
  }

  @action
  HIDE_ORDERCANCELREASON_MODAL() {
    // 此处无需toggleBottomSafearea，因为modal触发submit时已执行过
    this.UNVISIBLE_ORDERCANCELREASON_MODAL();
    setTimeout(() => {
      this.UNSHOW_ORDERCANCELREASON_MODAL();
      this.UPDATE_MODAL_ORDERCANCELREASON({});
    }, 400);
  }

  @action
  UNSHOW_ORDERCANCELREASON_MODAL() {
    this.isShowModalOrderCancelReason = false;
  }

  @action
  UNVISIBLE_ORDERCANCELREASON_MODAL() {
    this.isVisibleModalOrderCancelReason = false;
  }

  @action
  UPDATE_MODAL_ORDERCANCELREASON(data) {
    this.modalOrderCancelReason = data;
  }

  // Enquiry Details
  @action
  SHOW_ENQUIRYDETAILS_MODAL() {
    this.isShowModalEnquiryDetails = true;
    setTimeout(() => {
      this.VISIBLE_ENQUIRYDETAILS_MODAL();
    }, 100);
  }

  @action
  VISIBLE_ENQUIRYDETAILS_MODAL() {
    if (this.isShowModalEnquiryDetails) {
      this.isVisibleModalEnquiryDetails = true;
    }
  }

  @action
  HIDE_ENQUIRYDETAILS_MODAL() {
    this.UNVISIBLE_ENQUIRYDETAILS_MODAL();
    setTimeout(() => {
      this.UNSHOW_ENQUIRYDETAILS_MODAL();
      this.UPDATE_MODAL_ENQUIRYDETAILS({});
    }, 400);
  }

  @action
  UNSHOW_ENQUIRYDETAILS_MODAL() {
    this.isShowModalEnquiryDetails = false;
  }

  @action
  UNVISIBLE_ENQUIRYDETAILS_MODAL() {
    this.isVisibleModalEnquiryDetails = false;
  }

  @action
  UPDATE_MODAL_ENQUIRYDETAILS(data) {
    this.modalEnquiryDetails = data;
  }

  @action
  UPDATE_MODAL_ARTICLE_DETAIL_TRACKING_DATA(data) {
    this.articleDetailTrackingData = {
      ...this.articleDetailTrackingData,
      ...data,
    };
  }

  // 如果 modal 有展示的 就关闭 如果没有 就执行 callback
  @action
  HIDE_ALL_MODAL(callback) {
    const {
      isShowModalArticle,
      isVisibleModalArticle,
      isShowModalOrderList,
      isVisibleModalOrderList,
      isShowModalOrderCancelReason,
      isVisibleModalOrderCancelReason,
      isShowModalEnquiryDetails,
      isVisibleModalEnquiryDetails,
      popUpAnnouncementShow,
      isShowModalCsatCard,
    } = this;
    if (
      !isShowModalArticle
      && !isVisibleModalArticle
      && !isShowModalCsatCard
      && !isShowModalOrderList
      && !isVisibleModalOrderList
      && !isShowModalOrderCancelReason
      && !isVisibleModalOrderCancelReason
      && !isShowModalEnquiryDetails
      && !isVisibleModalEnquiryDetails
      && !popUpAnnouncementShow
    ) {
      callback && callback?.();
    } else {
      // modal - 文章
      this.isShowModalArticle = false;
      this.isVisibleModalArticle = false;

      // modal - Order列表
      this.isShowModalOrderList = false;
      this.isVisibleModalOrderList = false;

      // modal - csat card
      this.isShowModalCsatCard = false;

      // modal - ACL选 cancel reason
      this.isShowModalOrderCancelReason = false;
      this.isVisibleModalOrderCancelReason = false;

      // modal - Enquiry Details
      this.HIDE_ENQUIRYDETAILS_MODAL();

      // pop up announcement
      this.popUpAnnouncementShow = false;
    }
  }

  // 赋值新的 全局变量 hide 方法和  visible
  @action
  SET_GLOBAL_MODAL_CONFIG_VISIBLE(bool) {
    this.globalModalConfig.visible = bool;
  }

  @action
  SET_GLOBAL_MODAL_CONFIG_HIDE(cb) {
    this.globalModalConfig.hide = cb;
  }

  @action UPDATE_MODAL_POP_UP_ANNOUNCEMENT_SHOW(bool) {
    this.popUpAnnouncementShow = bool;
  }
  @action POP_UP_ANNOUNCEMENT_CONFIG(announcements) {
    if (announcements?.message_extra?.popup_announcement) {
      this.popUpAnnouncementData = announcements?.message_extra?.popup_announcement ?? {};
      this.popUpAnnouncementShow = true;
    }
  }

  @action
  UPDATE_SHOW_MODAL_UPDATE_APP(bool) {
    this.isShowModalUpdateApp = bool;
  }
}

const modalStore = new ModalStore();

export default modalStore;
